import { useEffect } from "react";

export const useReferrer = () => {
  useEffect(() => {
    if (
      typeof document !== "undefined" &&
      typeof localStorage !== "undefined"
    ) {
      const { referrer } = document;

      if (referrer && referrer !== "https://app.extensionkit.io/") {
        localStorage.setItem("lastReferrer", referrer);
      }
    }
  }, []);
};
